import { FormBase } from 'core/components';

export default class InventorySyncForm extends FormBase {
	constructor(hooks) {
		super(hooks);
	}
	setup() {
		return {
			fields: [
				{
					name: 'warehouse',
					label: 'INVENTORYSYNC.WAREHOUSE',
					rules: 'required',
				},
				{
					name: 'excel',
					label: 'INVENTORYSYNC.EXCEL',
					rules: 'required',
				},
				{
					name: 'note',
					label: 'INVENTORYSYNC.NOTE',
				},
			],
		};
	}
}



// WEBPACK FOOTER //
// ./src/modules/product-inventory/forms/InventorySyncForm.js